import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { ApplicationState, AppState } from '../../../store';
import { withSnackbar, ProviderContext } from 'notistack';
import { ITranslatorService } from '../../../services/Interfaces/ITranslatorService';
import { ApplicationContext, AppContext } from '../../../context/Contexts';
import {
  Box,
  Button,
  Card,
  CardContent,
  Tabs,
  Tab,
  IconButton,
  Dialog,
  DialogTitle,
  Grid,
  Typography,
  DialogContent,
  Tooltip,
  FormControlLabel,
  Switch,
  Paper
} from '@material-ui/core';
import { ScaleLoader } from 'react-spinners';
import MUIDataTable, {
  MUIDataTableColumnOptions,
  MUIDataTableMeta,
  SelectableRows
} from 'mui-datatables';
import { MUITranslations } from '../../../helpers/MUITableTranslations';
import { RouteComponentProps } from 'react-router';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { isNullOrUndefined } from 'util';
import _ from 'lodash';
import { OrganizationTypeCode } from '../../../helpers/Constants';
import { IReferential } from '../../../interfaces/IReferential';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import NumberFormat from 'react-number-format';
import {
  OrganizationSupplier,
  OrganizationSupplierProducerDiscount
} from '../../../interfaces/Organization';
import { SupplierProducer } from '../../../interfaces/Workflow';
import { IOrganizationService } from '../../../services/Interfaces/IOrganizationService';
import { IWorkflowService } from '../../../services/Interfaces/IWorkflowService';
import * as R from 'ramda';
import AddCircleTwoToneIcon from '@material-ui/icons/AddCircleTwoTone';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import CloseIcon from '@material-ui/icons/Close';
import moment from 'moment';

interface IOrganizationSupplierProducerDiscountsState {
  organizationSupplierProducerDiscounts: OrganizationSupplierProducerDiscount[];
  organizationSuppliers: OrganizationSupplier[];
  producerList: SupplierProducer[];
  isLoading: boolean;
  newOrganizationSupplierProducerDiscount: OrganizationSupplierProducerDiscount;
  newOrganizationSupplierProducerDiscountId: number | null;
  isDialogOpen: boolean;
  organizationId: number;
}

type IOrganizationSupplierProducerDiscountsProps = { appState: AppState } & ProviderContext &
  RouteComponentProps<{ id: string }>;

class OrganizationSupplierProducerDiscounts extends React.PureComponent<
  IOrganizationSupplierProducerDiscountsProps,
  IOrganizationSupplierProducerDiscountsState
> {
  private translatorService!: ITranslatorService;
  private organizationService!: IOrganizationService;
  private workflowService!: IWorkflowService;

  static contextType = ApplicationContext;
  private newOrganizationSupplierProducerDiscount = {
    id: 0
  } as OrganizationSupplierProducerDiscount;

  state = {
    organizationSupplierProducerDiscounts: [],
    organizationSuppliers: [],
    producerList: [],
    isLoading: false,
    organizationId: 0,
    newOrganizationSupplierProducerDiscount: this.newOrganizationSupplierProducerDiscount,
    newOrganizationSupplierProducerDiscountId: null,
    isDialogOpen: false,
    organizationId: 0
  } as IOrganizationSupplierProducerDiscountsState;

  public componentDidMount() {
    this.setState(
      {
        isLoading: true
      },
      async () => {
        await this.loadData();
      }
    );
  }

  loadData = async () => {
    const hoId = Number.parseInt(this.props.match.params.id);

    if (Number.isNaN(hoId)) {
      return;
    }

    const [organizationSupplierProducerDiscounts, producerList, organizationSuppliers, suppliers] =
      await Promise.all([
        this.organizationService.GetOrganizationSupplierProducerDiscounts(hoId),
        this.workflowService.GetSupplierProducers(),
        this.organizationService.GetOrganizationSuppliersByOrgId(hoId),
        this.organizationService.GetHOOrganizationsByTypes([OrganizationTypeCode.SUPPLIER])
      ]);

    organizationSuppliers.forEach((item) => {
      const supplier = suppliers.find(
        (supplierItem) => !R.isNil(item.supplierId) && supplierItem.id === item.supplierId
      );
      item.supplier = R.isNil(supplier) ? null : supplier;
    });

    organizationSupplierProducerDiscounts.forEach((item) => {
      if (item.organizationSupplier != null) {
        const supplier = suppliers.find(
          (supplierItem) =>
            !R.isNil(item.organizationSupplier?.supplierId) &&
            supplierItem.id === item.organizationSupplier.supplierId
        );
        const producer = producerList.find((producerItem) => producerItem.id === item.producerId);

        item.supplierProducer = R.isNil(producer) ? null : producer;
        item.supplierId = !R.isNil(supplier) ? supplier.id : 0;
        item.organizationSupplier.supplier = R.isNil(supplier) ? null : supplier;
      }
    });

    console.log('organizationSuppliers', organizationSuppliers);
    console.log('organizationSupplierProducerDiscounts', organizationSupplierProducerDiscounts);

    this.setState({
      organizationSupplierProducerDiscounts: organizationSupplierProducerDiscounts,
      producerList: producerList,
      organizationSuppliers: organizationSuppliers,
      isLoading: false,
      organizationId: hoId
    });
  };

  public hasRight = (right: string): boolean => {
    return this.props.appState!.user!.profile.role.includes(right);
  };

  private handleSupplierProducerChange = (newValue: SupplierProducer | null) => {
    this.setState({
      newOrganizationSupplierProducerDiscount: {
        ...this.state.newOrganizationSupplierProducerDiscount,
        supplierProducer: newValue,
        producerId: newValue !== null ? newValue!.id : 0
      }
    });
  };

  private handleOrganizationSupplierChange = (newValue: OrganizationSupplier | null) => {
    this.setState({
      newOrganizationSupplierProducerDiscount: {
        ...this.state.newOrganizationSupplierProducerDiscount,
        organizationSupplier: newValue,
        organizationSupplierId: newValue !== null ? newValue.id : 0,
        supplier: newValue?.supplier || null,
        supplierId: newValue !== null ? newValue.supplierId : 0,
        discountTariff: newValue !== null ? newValue.discountTariff : 0
      }
    });
  };

  private handleDiscountTariffChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      newOrganizationSupplierProducerDiscount: {
        ...this.state.newOrganizationSupplierProducerDiscount,
        discountTariff: event.target.value === null ? 0 : parseInt(event.target.value)
      }
    });
  };

  private handleDiscountChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      newOrganizationSupplierProducerDiscount: {
        ...this.state.newOrganizationSupplierProducerDiscount,
        discount: event.target.value === null ? 0 : parseInt(event.target.value)
      }
    });
  };

  public saveOrganizationSupplierProducerDiscount = async () => {
    if (this.state.newOrganizationSupplierProducerDiscountId === null) {
      if (
        this.state.organizationSupplierProducerDiscounts.findIndex(
          (item) =>
            item.producerId === this.state.newOrganizationSupplierProducerDiscount!.producerId &&
            item.supplierId === this.state.newOrganizationSupplierProducerDiscount!.supplierId
        ) !== -1
      ) {
        this.props.enqueueSnackbar(
          this.translatorService.Tranlate(
            'ORGANIZATION_SUPPLIER_PRODUCER_DISCOUNT_EXISTS',
            'Discount pentru furnizor si producator exista deja!'
          ),
          { variant: 'error' }
        );
        return;
      }
    } else {
      if (
        this.state.organizationSupplierProducerDiscounts.findIndex(
          (item) =>
            item.producerId === this.state.newOrganizationSupplierProducerDiscount!.producerId &&
            item.supplierId === this.state.newOrganizationSupplierProducerDiscount!.supplierId &&
            item.id !== this.state.newOrganizationSupplierProducerDiscountId
        ) !== -1
      ) {
        this.props.enqueueSnackbar(
          this.translatorService.Tranlate(
            'ORGANIZATION_SUPPLIER_PRODUCER_DISCOUNT_EXISTS',
            'Discount pentru furnizor si producator exista deja!'
          ),
          { variant: 'error' }
        );
        return;
      }
    }

    try {
      await this.organizationService.AddOrganizationSupplierProducerDiscount(
        this.state.newOrganizationSupplierProducerDiscount
      );

      await this.loadData();

      this.closeDialog();

      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  NumberFormatCustom = (props: any) => {
    const { inputRef, onChange, ...other } = props;

    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values: any) => {
          onChange({
            target: {
              value: values.value
            }
          });
        }}
        thousandSeparator
        decimalScale={2}
        isNumericString
        suffix=" %"
      />
    );
  };

  getOrganizationSuppliersOptions = (): OrganizationSupplier[] => {
    return (
      this.state.organizationSuppliers.sort((a, b) => {
        const nameA = a.supplier?.name ?? '';
        const nameB = b.supplier?.name ?? '';
        return nameA.localeCompare(nameB);
      }) || []
    );
  };

  public renderAddForm() {
    return (
      <ValidatorForm
        onSubmit={this.saveOrganizationSupplierProducerDiscount}
        instantValidate={true}
      >
        <Box mb={2}>
          <Autocomplete
            id="suppliers"
            fullWidth
            options={this.getOrganizationSuppliersOptions()}
            value={this.state.newOrganizationSupplierProducerDiscount.organizationSupplier}
            onChange={(e: any, newValue: OrganizationSupplier | null) =>
              this.handleOrganizationSupplierChange(newValue)
            }
            getOptionLabel={(option: OrganizationSupplier) => option.supplier?.name || ''}
            renderInput={(params) => (
              <TextValidator
                {...params}
                name="suppliers"
                value={
                  this.state.newOrganizationSupplierProducerDiscount.organizationSupplier?.supplier
                    ?.name || ''
                }
                label={this.translatorService.Tranlate(
                  'WORKFLOW_SUPPLIERS_TAB_SUPPLIER_LABEL',
                  'Furnizor'
                )}
                fullWidth
                validators={['required']}
                errorMessages={[
                  this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
                ]}
              />
            )}
          />
        </Box>

        <Box mb={2}>
          <TextValidator
            fullWidth
            name="discountTariff"
            id="discountTariff"
            value={this.state.newOrganizationSupplierProducerDiscount.discountTariff}
            onChange={this.handleDiscountTariffChange}
            label={this.translatorService.Tranlate(
              'WORKFLOW_GENERAL_DISCOUNT_TARIFF',
              'Discount Furnizor (%)'
            )}
            validators={['required', 'minNumber:0', 'maxNumber:100']}
            errorMessages={[
              this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu'),
              this.translatorService.Tranlate(
                'WORKFLOW_SUPPLIERS_TAB_DISCOUNT_VALIDATORS_NUMBER_BETWENN',
                'Valoarea discount-ului trebuie sa fie cuprinsa intre 0 si 100'
              ),
              this.translatorService.Tranlate(
                'WORKFLOW_SUPPLIERS_TAB_DISCOUNT_VALIDATORS_NUMBER_BETWENN',
                'Valoarea discount-ului trebuie sa fie cuprinsa intre 0 si 100'
              )
            ]}
            InputProps={{
              inputComponent: this.NumberFormatCustom
            }}
          />
        </Box>

        <Box mb={2}>
          <Autocomplete
            id="supplierProducer"
            fullWidth
            options={this.state.producerList}
            value={this.state.newOrganizationSupplierProducerDiscount.supplierProducer}
            onChange={(e: any, newValue: SupplierProducer | null) =>
              this.handleSupplierProducerChange(newValue)
            }
            getOptionLabel={(option: SupplierProducer) => option.producer || ''}
            renderInput={(params) => (
              <TextValidator
                {...params}
                name="supplierProducer"
                value={
                  this.state.newOrganizationSupplierProducerDiscount.supplierProducer?.producer || ''
                }
                label={this.translatorService.Tranlate(
                  'WORKFLOW_SUPPLIER_PRODUCER_PRODUCER',
                  'Producator'
                )}
                fullWidth
              />
            )}
          />
        </Box>

        <Box mb={2}>
          <TextValidator
            fullWidth
            name="discount"
            id="discount"
            value={this.state.newOrganizationSupplierProducerDiscount.discount}
            onChange={this.handleDiscountChange}
            label={this.translatorService.Tranlate(
              'WORKFLOW_SUPPLIER_PRODUCER_DISCOUNT',
              'Discount Producator (%)'
            )}
            validators={['required', 'minNumber:0', 'maxNumber:100']}
            errorMessages={[
              this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu'),
              this.translatorService.Tranlate(
                'WORKFLOW_SUPPLIERS_TAB_DISCOUNT_VALIDATORS_NUMBER_BETWENN',
                'Valoarea discount-ului trebuie sa fie cuprinsa intre 0 si 100'
              ),
              this.translatorService.Tranlate(
                'WORKFLOW_SUPPLIERS_TAB_DISCOUNT_VALIDATORS_NUMBER_BETWENN',
                'Valoarea discount-ului trebuie sa fie cuprinsa intre 0 si 100'
              )
            ]}
            InputProps={{
              inputComponent: this.NumberFormatCustom
            }}
          />
        </Box>

        <div className="text-right">
          <Button className="m-2" variant="outlined" color="default" onClick={this.closeDialog}>
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_CANCEL_BTN', 'Anuleaza')}
          </Button>
          <Button className="m-2" variant="contained" color="secondary" type="submit">
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_SAVE_BTN', 'Salveaza')}
          </Button>
        </div>
      </ValidatorForm>
    );
  }

  getColumns = () => {
    const columns = [
      {
        name: 'id',
        options: { display: 'excluded', filter: false } as MUIDataTableColumnOptions
      },
      {
        name: 'organizationSupplier.supplier.name',
        label: this.translatorService.Tranlate('WORKFLOW_SUPPLIERS_TAB_SUPPLIER_HEADER', 'Furnizor')
      },
      {
        name: 'organizationSupplier.discountTariff',
        label: this.translatorService.Tranlate(
          'WORKFLOW_GENERAL_DISCOUNT_TARIFF',
          'Discount Furnizor (%)'
        )
      },
      {
        name: 'supplierProducer',
        label: this.translatorService.Tranlate('WORKFLOW_SUPPLIER_PRODUCER_PRODUCER', 'Producator'),
        options: {
          sort: true,
          customSort: (a: SupplierProducer, b: SupplierProducer) => {
            return a.producer!.localeCompare(b.producer!);
          },
          customBodyRender: (value: SupplierProducer) => {
            return value ? value.producer : '';
          }
        } as MUIDataTableColumnOptions
      },
      {
        name: 'discount',
        label: this.translatorService.Tranlate(
          'WORKFLOW_SUPPLIER_PRODUCER_DISCOUNT',
          'Discount Producator (%)'
        )
      },
      {
        name: 'dateModification',
        label: this.translatorService.Tranlate('USERS_DATE_MODIFICATION_HEADER', 'Data Modificare'),
        options: {
          filter: false,
          sortDirection: 'desc',
          customBodyRender: (value: Date) =>
            moment.utc(value).local().format(this.props.appState.longDateFormat)
        } as MUIDataTableColumnOptions
      },
      {
        name: '',
        options: {
          viewColumns: false,
          filter: false,
          setCellHeaderProps: () => ({ align: 'center' }),
          setCellProps: () => ({ align: 'center' }),
          customBodyRender: (value: boolean, tableMeta: MUIDataTableMeta) => {
            return (
              <>
                <IconButton
                  aria-label="edit"
                  color="primary"
                  className="text-primary"
                  size="small"
                  onClick={(e) =>
                    this.newOrganizationSupplierProducerDiscountPopup(tableMeta.rowData[0])
                  }
                >
                  <EditOutlinedIcon />
                </IconButton>
                <IconButton
                  aria-label="delete"
                  color="inherit"
                  className="text-danger"
                  size="small"
                  onClick={(e) => this.deleteOrganizationSupplierProducerDiscount(e, tableMeta)}
                >
                  <DeleteOutlineTwoToneIcon />
                </IconButton>
              </>
            );
          }
        }
      }
    ];
    return columns;
  };

  deleteOrganizationSupplierProducerDiscount = async (event: any, tableMeta: MUIDataTableMeta) => {
    try {
      const id = tableMeta.rowData[0];

      await this.organizationService.RemoveOrganizationSupplierProducerDiscount(id);
      await this.loadData();

      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  newOrganizationSupplierProducerDiscountPopup = async (
    organizationSupplierProducerDiscountId: number | null
  ) => {
    let organizationSupplierProducerDiscount: OrganizationSupplierProducerDiscount;
    if (organizationSupplierProducerDiscountId == null) {
      organizationSupplierProducerDiscount = {
        ...this.state.newOrganizationSupplierProducerDiscount
      } as OrganizationSupplierProducerDiscount;
    } else {
      organizationSupplierProducerDiscount = this.state.organizationSupplierProducerDiscounts.find(
        (item) => item.id === organizationSupplierProducerDiscountId
      )!;
    }
    organizationSupplierProducerDiscount.discountTariff =
      organizationSupplierProducerDiscount.organizationSupplier?.discountTariff || 0;

    this.setState({
      isDialogOpen: true,
      newOrganizationSupplierProducerDiscount: organizationSupplierProducerDiscount,
      newOrganizationSupplierProducerDiscountId: organizationSupplierProducerDiscountId
    });
  };

  closeDialog = async () => {
    this.setState({
      isDialogOpen: false,
      newOrganizationSupplierProducerDiscount: this.newOrganizationSupplierProducerDiscount,
      newOrganizationSupplierProducerDiscountId: null
    });
  };

  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.workflowService = (this.context as AppContext).workflowService;
    this.organizationService = (this.context as AppContext).organizationService;

    const options = {
      filter: true,
      selectableRows: 'none' as SelectableRows,
      selectableRowsOnClick: false,
      print: false,
      download: false,
      textLabels: MUITranslations.GetTranslations(this.translatorService),
      sort: false,
      customToolbar: () => {
        return (
          <div>
            <Tooltip title={this.translatorService.Tranlate('Add', 'Adauga')}>
              <IconButton
                aria-label="add"
                color="secondary"
                className="m-2"
                onClick={(e) => this.newOrganizationSupplierProducerDiscountPopup(null)}
              >
                <AddCircleTwoToneIcon />
              </IconButton>
            </Tooltip>
          </div>
        );
      }
    };

    return (
      <Fragment>
        <Box>
          <Card>
            <CardContent>
              <Tabs
                value={0}
                indicatorColor="primary"
                textColor="primary"
                variant="standard"
                color="primary"
                aria-label="disabled tabs example"
              >
                <Tab
                  className="text-capitalize"
                  label={this.translatorService.Tranlate(
                    'ORGANIZATION_SUPPLIERS_PRODUCER_DISCOUNTS',
                    'Discounturi Producatori furnizori'
                  )}
                />
              </Tabs>
            </CardContent>
          </Card>
        </Box>
        <Box mt={1} pt={1}>
          <div className="d-flex flex-row text-center flex-wrap justify-content-center">
            <ScaleLoader color={'var(--primary)'} loading={this.state.isLoading} />
          </div>
          {!this.state.isLoading ? (
            <MUIDataTable
              title={''}
              data={this.state.organizationSupplierProducerDiscounts}
              columns={this.getColumns()}
              options={options}
            />
          ) : null}
        </Box>
        {this.state.isDialogOpen ? (
          <Dialog
            onClose={this.closeDialog}
            aria-labelledby="customized-dialog-title"
            open={this.state.isDialogOpen}
            fullScreen={false}
            fullWidth={true}
          >
            <DialogTitle id="customized-dialog-title">
              <Grid container>
                <Grid item xs={11}>
                  <Typography className="MuiTypography-h4">
                    {!this.state.newOrganizationSupplierProducerDiscountId
                      ? this.translatorService.Tranlate(
                          'ORGANIZATION_SUPPLIER_PRODUCER_DISCOUNT_ADD_MODAL_TITLE',
                          'Adauga discount producator pentru furnizor'
                        )
                      : this.translatorService.Tranlate(
                          'ORGANIZATION_SUPPLIER_PRODUCER_DISCOUNT_EDIT_MODAL_TITLE',
                          'Actualizeaza discount producator pentru furnizor'
                        )}
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <IconButton aria-label="close" onClick={this.closeDialog} size={'small'}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </DialogTitle>
            <DialogContent dividers>{this.renderAddForm()}</DialogContent>
          </Dialog>
        ) : (
          ''
        )}
      </Fragment>
    );
  }
}

export default connect(
  (state: ApplicationState) => ({
    appState: state.app
  }),
  null
)(withSnackbar(OrganizationSupplierProducerDiscounts as any));
